import { Box, Checkbox, Flex, Grid, Text } from "@chakra-ui/react";
import { PlusIcon } from "lucide-react";
import {
	NewOrderEarprintShippingType,
	useNewOrderStore,
} from "../../../stores/order.store";
import { useCenter } from "../../../hooks/centers.hooks";
import PageTitle from "../../../components/PageTitle";
import { OrdersNewPageBaseLayout } from "./OrdersNewPageBaseLayout";
import { OrdersNewPageBaseLayoutButton } from "./OrdersNewPageBaseLayoutButton";
import Announcement from "../../../components/Announcement";
import { AnnouncementType } from "../../../types/announcement.types";
import { useAdminSettings } from "../../../hooks/admin_settings.hooks";

export const ChooseShippingLayout = () => {
	const { center, earprintShippingType, isPriority, togglePriority } =
		useNewOrderStore();
	const { data: refreshedCenter } = useCenter(center?.id);
	const { data: adminSettings } = useAdminSettings();

	return (
		<OrdersNewPageBaseLayout>
			<Flex direction="column" gap={8} alignItems="center">
				<div className="w-full">
					<Announcement
						type={AnnouncementType.COMMAND}
						infoStyle="border-gray-200! bg-gray-50"
					/>
				</div>

				<PageTitle>Estimation des délais</PageTitle>

				{adminSettings && (
					<Grid
						gridTemplateColumns="1fr 24px 1fr 24px 1fr"
						gap={4}
						alignItems="center"
					>
						<div className="border! border-brand-200! rounded-lg! p-2 bg-brand-50">
							<Text fontSize="14px" fontWeight={500}>
								Temps de réception moy.
							</Text>
							<Text fontSize="32px" fontWeight={600} className="text-brand-600">
								{earprintShippingType === NewOrderEarprintShippingType.PHYSICAL
									? `~ ${adminSettings?.meanDaysReceiptTime}j`
									: "0j"}
							</Text>
						</div>
						<PlusIcon className="text-brand-600" strokeWidth={3} />
						<div className="border! border-brand-200! rounded-lg! p-2 bg-brand-50">
							<Text fontSize="14px" fontWeight={500}>
								Temps de fabrication moy.
							</Text>
							<Text fontSize="32px" fontWeight={600} className="text-brand-600">
								{isPriority === true
									? `~ ${adminSettings?.meanDaysExpressProductionTime}j`
									: `~ ${adminSettings?.meanDaysProductionTime}j`}
							</Text>
						</div>
						<PlusIcon className="text-brand-600" strokeWidth={3} />
						<div className="border! border-brand-200! rounded-lg! p-2 bg-brand-50">
							<Text fontSize="14px" fontWeight={500}>
								Temps d'expédition moy.
							</Text>
							<Text fontSize="32px" fontWeight={600} className="text-brand-600">
								{`~ ${adminSettings?.meanDaysShippingTime}j`}
							</Text>
						</div>
					</Grid>
				)}

				<Box
					w="600px"
					border="solid 1px"
					borderColor="gray.200"
					rounded="md"
					shadow="xs"
					p={4}
				>
					<Text lineHeight="21px" fontSize="16px" fontWeight="600">
						Adresse de facturation
					</Text>
					{refreshedCenter?.enterprise?.address && (
						<>
							<Text lineHeight="21px" fontSize="16px" fontWeight="300">
								{refreshedCenter?.enterprise?.name}
							</Text>
							<Text lineHeight="21px" fontSize="16px" fontWeight="300">
								{refreshedCenter?.enterprise?.address?.streetNumber}{" "}
								{refreshedCenter?.enterprise?.address?.streetName}
							</Text>
							<Text
								lineHeight="21px"
								fontSize="16px"
								fontWeight="300"
								textTransform="uppercase"
							>
								{refreshedCenter?.enterprise?.address?.postalCode}{" "}
								{refreshedCenter?.enterprise?.address?.city}
							</Text>
						</>
					)}
					{!refreshedCenter?.enterprise?.address && (
						<Text lineHeight="21px" fontSize="16px" fontWeight="100">
							Ce centre n'a pas d'address de facturation
						</Text>
					)}
				</Box>

				<Box
					w="600px"
					rounded="md"
					shadow="xs"
					border="solid 1px"
					borderColor="gray.200"
					p={4}
				>
					<Text lineHeight="21px" fontSize="16px" fontWeight="600">
						Adresse de livraison
					</Text>
					{refreshedCenter?.shippingAddress && (
						<>
							<Text lineHeight="21px" fontSize="16px" fontWeight="300">
								{refreshedCenter.name}
							</Text>
							<Text lineHeight="21px" fontSize="16px" fontWeight="300">
								{refreshedCenter.shippingAddress?.streetNumber}{" "}
								{refreshedCenter.shippingAddress?.streetName}
							</Text>
							<Text
								lineHeight="21px"
								fontSize="16px"
								fontWeight="300"
								textTransform="uppercase"
							>
								{refreshedCenter.shippingAddress?.postalCode}{" "}
								{refreshedCenter.shippingAddress.city}
							</Text>
						</>
					)}
					{!refreshedCenter?.shippingAddress && (
						<Text lineHeight="21px" fontSize="16px" fontWeight="100">
							Ce centre n'a pas d'address de facturation
						</Text>
					)}
				</Box>

				{adminSettings && (
					<Grid
						gridTemplateColumns={"20px 1fr 120px"}
						gap={2}
						onClick={togglePriority}
						w="600px"
						rounded="md"
						shadow="xs"
						border="solid 1px"
						borderColor="gray.200"
						p={4}
					>
						<Checkbox
							isChecked={isPriority}
							onChange={togglePriority}
							colorScheme="brand"
						/>
						<Text lineHeight="21px" fontSize="16px" fontWeight="100">
							<span className="font-semibold">Commande prioritaire :</span>{" "}
							départ sous 24h/48h à réception des empreintes
						</Text>
						<Text
							fontSize="18px"
							fontWeight={600}
							className="text-brand-700"
							textAlign="right"
						>
							{`+ ${adminSettings.expressPrice / 100} €`}
						</Text>
					</Grid>
				)}

				<OrdersNewPageBaseLayoutButton />
			</Flex>
		</OrdersNewPageBaseLayout>
	);
};
